module.exports = __webpack_public_path__ + "assets/33ddcff0046e4c55975d7bd6af425c16.mp3";


/*****************
 ** WEBPACK FOOTER
 ** C:/Users/taylorice/Documents/Roc2/engine/public-src/spingames/panel/sounds/buttons/help.mp3
 ** module id = 24
 ** module chunks = 0
 **/